<template>
  <eagle-list
    :list-key="listKey"
  ></eagle-list>
</template>

<script>
import listMixin from '@/components/list/mixins/listMixin'
import listConfig from './siteAdminGroupListConfig'
export default {
  mixins: [listMixin],
  data: () => ({
    listKey: 'site-admin-group-list',
    meta: {},
  }),
  methods: {
    async beforeIndex() {
      await Promise.all([])
    },
    async indexApi(params) {
      return await this.$api.collection.siteAdminGroupApi.index(params)
    },
    async patchApi(value, row, config) {
      const target = row.id
      const column = config.key
      return await this.$api.collection.siteAdminGroupApi.patch(target, column, value)
    },
    async deleteApi(target) {
      return await this.$api.collection.siteAdminGroupApi.delete(target)
    },
    async batchApi(targets, column, value) {
      return await this.$api.collection.siteAdminGroupApi.batch(targets, column, value)
    },
    async batchDeleteApi(targets) {
      return await this.$api.collection.siteAdminGroupApi.batchDelete(targets)
    },
    getListConfig() {
      return listConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
